import gql from 'graphql-tag';

export default gql`
  mutation ChangePasswordMutation($request: UserChangePasswordInputType!) {
    me {
      changePassword(request: $request) {
        __typename
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on BasicMutationSuccess {
          code
        }
      }
    }
  }
`;
